<script setup>
import FilterComponent from '@/@core/components/custom/FilterComponent.vue'
import AnalyticsTicketTracker from '@/views/survey/ticket-management/AnalyticsTicketTracker.vue'
import CustomerCommunicationDrawer from '@/views/service-desk/customer-communication/Drawer.vue'
import CustomerCommunicationLogDrawer from '@/views/service-desk/customer-communication/LogDrawer.vue'
import TicketFormDrawer from '@/views/service-desk/drawer/TicketFormDrawer.vue'
import TicketTable from '@/views/survey/ticket-management/TicketTable.vue'
import TicketDrawer from '@/views/survey/ticket-management/TicketDrawer.vue'

definePage({
  meta: {
    name: "Ticket Management",
    subject: "survey.menu",
    action: "ticket_management",
  },
})

const route = useRoute()

const ticketFilters = ref()

const { 
  data: filterOptions,
} = await useApi(createUrl('/survey/tickets/filters', {
  query: {
    type: 'service-desk',
  },
}))

const isTicketDrawerVisible = ref(false)
const ticketDrawerData = ref()
const refTicketTable = ref()
const communicationDrawerData = ref()

const showTicket = feedbackData => {
  setTimeout(() => {
    ticketDrawerData.value = feedbackData
    isTicketDrawerVisible.value = true
  }, 1000)
}

// check if ticket id is present in the route
if(route.query.ticket){
  const ticketId = route.query.ticket
  const { data: ticketData } = await useApi(createUrl(`/survey/tickets/${ticketId}`))
  if(ticketData.value){
    showTicket(ticketData.value)
  }
}

const isCommunicationDrawerVisible = ref(false)

const showCommunicationDrawer= (feedbackData, type, communicationFor='') => {
  communicationDrawerData.value = feedbackData
  communicationDrawerData.value.communicationFor = communicationFor
  isCommunicationDrawerVisible.value = true
}

const isCommunicationLogDrawerVisible = ref(false)

const showCommunicationLogDrawer = (feedbackData, type) => {
  communicationDrawerData.value = feedbackData
  isCommunicationLogDrawerVisible.value = true
}

const refTicketTracker =ref(null)

const refreshTicketData = async (closeDrawer = true) => {
  if (closeDrawer) isTicketDrawerVisible.value = false
  refTicketTable.value?.fetchTickets()
  refTicketTracker.value?.fetchStatusGraph()
}

const isCreateTicketDrawerVisible = ref(false)

const onUpdateTableFilter = data => {
  ticketFilters.value = {
    ...ticketFilters.value,
    ...data,
  }
}
</script>

<template>
  <VRow class="match-height mb-6">
    <VCol
      cols="12"
      md="6"
      lg="6"
    >
      <FilterComponent
        v-model:filters="ticketFilters"
        :filters-options="filterOptions"
      />
    </VCol>
    <VCol
      cols="12"
      md="6"
      lg="6"
    >
      <AnalyticsTicketTracker
        ref="refTicketTracker"
        :ticket-filters="ticketFilters"
        page="ticket-management"
      />
    </VCol>
  </VRow>

  <TicketTable
    ref="refTicketTable"
    :ticket-filters="ticketFilters"
    page="ticket-management"
    @show-ticket="showTicket"
    @show-communication-drawer="showCommunicationDrawer"
    @show-communication-log-drawer="showCommunicationLogDrawer"
    @show-ticket-create-drawer="() => {
      isCreateTicketDrawerVisible = true
    }"
    @update:filter="onUpdateTableFilter"
  />

  <TicketDrawer
    v-model:isDrawerOpen="isTicketDrawerVisible"
    :ticket-data="ticketDrawerData"
    @refresh-ticket-data="refreshTicketData"
    @show-feedback-response="showFeedbackResponse"
    @show-communication-drawer="showCommunicationDrawer"
  />
</template>
